import { API_URL } from './config.service';
import { ApplicationProducts } from '@mynexus/mynexus-ui-lib';

export const APP_PRODUCT: ApplicationProducts = {
  url: API_URL,
};
